export default "__VITE_ASSET__57a32e86__"